<template>
  <Dashboard grafana-path="/d/RKYyU6eMk/netradyne-sign-violations-pivot" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "NetradyneSignViolationsDriverPivot",

  routing: {
    localizationKey: "menu.tab.sign_violations",
    icon: "mdi-table",
    path: "/netradyne_sign_violations",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
